import { render, staticRenderFns } from "./SupportContact.vue?vue&type=template&id=c138f3ee&scoped=true"
import script from "./SupportContact.vue?vue&type=script&lang=js"
export * from "./SupportContact.vue?vue&type=script&lang=js"
import style0 from "./SupportContact.vue?vue&type=style&index=0&id=c138f3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c138f3ee",
  null
  
)

export default component.exports